<template>
    <span>
        <criarenquete></criarenquete>
    </span>
</template>

<script>
import Criarenquete from '@/components/Criar-Enquete';

export default {
    name: 'cadcriarenquete',
    components: {
        Criarenquete
    }
};
</script>